import Axios from 'axios';
import HttpClient from './http-client';
import URL from './url';

export default class CommonApi {

    static getCountryCodeList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.COUNTRY_LIST_ALL + "?" + params.join('&') : URL.COUNTRY_LIST_ALL;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }


    static getCountryCode(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.COUNTRY_LIST + "?" + params.join('&') : URL.COUNTRY_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }


    static getMisc(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.MISC + "?" + params.join('&') : URL.MISC;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getSubscriptions(payload = {}) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.SUBSCRIPTIONS + "?" + params.join('&') : URL.SUBSCRIPTIONS;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getCities(payload = {}) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.CITIES_LIST + "?" + params.join('&') : URL.CITIES_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static addMiscellaneous(payload) {
        return HttpClient.post(URL.BASE_URL + URL.MISC, null, payload);
    }

    static discountDetails(payload = {}) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_DISCOUNT_DETAILS + "?" + params.join('&') : URL.GET_DISCOUNT_DETAILS;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static addClaimDetails(payload) {
        return HttpClient.post(URL.BASE_URL + URL.CLAIM_DETAILS, null, payload);
    }

    static getSignedUrl(payload) {
        let fileName = payload.fileName;

        let url = URL.BASE_URL + URL.CLAIMSIGNURL;

        url += `?fileName=${fileName}`;

        return Axios.get(url, payload);
    }

    static getSignedUrlForCheatSheet(payload) {
        let fileName = payload.fileName;

        let url = URL.BASE_URL + URL.CHEATSHEETSIGNURL;

        url += `?fileName=${fileName}`;

        return Axios.get(url, payload);
    }

    static uploadFileAwsS3(signedUrl, file, progressCallback) {
        let options = {
            headers: {
                "Content-Type": file.type
            },
            onUploadProgress: progressCallback
        };
        return Axios.put(signedUrl, file, options);
    }

    static getSearchedVideoLearningContent(payload = {}) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.VIDEO_CONTENT_SEARCH + "?" + params.join('&') : URL.VIDEO_CONTENT_SEARCH;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);


    }

    static createFFLCurriculumDownloadedUserInfo(payload) {
        return HttpClient.post(URL.BASE_URL + URL.FFL_CURRICULUM_DOWNLOAD, null, payload);

    }

     static sendErrorLogs(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SEND_ERROR_LOGS, null, payload);

    }

    
    static getPracticeQuestion(payload) {
        console.log('called')

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.PRACTICE_QUESTION_LIST + "?" + params.join('&') : URL.PRACTICE_QUESTION_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getWorksheetChapterList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.WORKSHEET_CHAPTER_LIST + "?" + params.join('&') : URL.WORKSHEET_CHAPTER_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getPerformanceReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.PERFORMANCE_REPORT + "?" + params.join('&') : URL.PERFORMANCE_REPORT;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getStudentDiagnosticReportPDF(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.STUDENT_DIAGNOSTIC_REPORT_PDF + "?" + params.join('&') : URL.STUDENT_DIAGNOSTIC_REPORT_PDF;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }


    static getConfigurationsList(payload) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.CONFIGURATIONS_LIST + "?" + params.join('&') : URL.CONFIGURATIONS_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getThemeList(payload) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.CATEGORY_THEME_LIST + "?" + params.join('&') : URL.CATEGORY_THEME_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }


    static getStudentClickerList(payload) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.STUDENTS_CLICKER_LIST + "?" + params.join('&') : URL.STUDENTS_CLICKER_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getAllStudentsReportPdf(payload) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_ALL_STUDENT_PERFORMANCE_PDF + "?" + params.join('&') : URL.GET_ALL_STUDENT_PERFORMANCE_PDF;
        return HttpClient.get(URL.BASE_URL + paramsList, payload, {responseType : 'blob'});
    }

    static getApplicationConfiguration(payload) {

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.APPLICATION_CONFIGUATION + "?" + params.join('&') : URL.APPLICATION_CONFIGUATION;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

     static updateStaffSubjectInfo(payload) {
        return HttpClient.put(URL.BASE_URL + URL.UPDATE_STAFF_SUBJECT_INFO, null, payload);
    }

}
